import React from 'react'
import Scroll from "../../Components/ScrollToTop"
import Banner from "../../Components/Banner/Contest"
import Main from "../../Components/Contest/Contest"

function Contest() {
  return (
    <div>
      <Scroll/>
      <Banner/>
      <Main/>
    </div>
  )
}

export default Contest
